import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable, Injector, PLATFORM_ID, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { LoaderService } from '../../shared/components/loader/loader.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private httpRequestCount = 0;

    constructor(
        private oidcSecurityService: OidcSecurityService,
        private router: Router,
        private injector: Injector,
        private loaderService: LoaderService,
        private translate: TranslateService,
        private toastr: ToastrService,
        @Inject(PLATFORM_ID) private platformId) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.httpRequestCount++;

        if (this.httpRequestCount >= 1) {
            this.loaderService.show();
        }

        if (this.oidcSecurityService === undefined) {
            this.oidcSecurityService = this.injector.get(OidcSecurityService);
        }
        const token = this.oidcSecurityService.getToken();
        if (token) {
            let headers = req.headers.set('Authorization', 'Bearer ' + token);

            return next.handle(req.clone({ headers: headers }))
                .pipe(
                    tap(event => {
                        if (event instanceof HttpResponse) {

                        }
                    }),
                    catchError((err: any) => this.handleAuthErr(err)),
                    finalize(() => {
                        this.httpRequestCount--;
                        if(this.httpRequestCount <= 0) {
                            this.loaderService.hide();
                        }
                        return;
                    })
                );
        } else {
            return next.handle(req)
                .pipe(
                    tap(event => {
                        if (event instanceof HttpResponse) {

                        }
                    }),
                    catchError((err: any) => this.handleAuthErr(err)),
                    finalize(() => {
                        this.httpRequestCount--;
                        if(this.httpRequestCount <= 0) {
                            this.loaderService.hide();
                        }
                        return;
                    })
                );
        }
    }

    private handleAuthErr(err: HttpErrorResponse): Observable<any> {
        switch (err.status) {
            case 401: {
                this.oidcSecurityService.logoff(url => window.location.href = url);
                // this.oidcSecurityService.logoff();
                break;
            }
            case 403: {
              if (err.error != null) {
                this.translate.get(err.error).subscribe(res => {
                    this.toastr.error(res);
                });
              }

              setTimeout(() => {
                if (isPlatformBrowser(this.platformId)) {
                  location.assign(`/`);
                }
              }, 1000);
              break;
            }
            case 400: {
                break;
            }
            case 404: {
                this.router.navigateByUrl(`/`);
                break;
            }
            default: {
                console.log(err);
                break;
            }
        }

        return throwError(err);
    }
}
